import portsApi from '@/framework/ports/portsApi';

const UserActionFrontend = {
  onUserInteraction: (callback: (size: string) => void) =>
    portsApi.on('UserAction.onUserAction', callback),
};

export default UserActionFrontend;
